import { Sender, ISenderSendParams } from "./sender";
import {
  assignObject,
  enhanceObjectCopy,
  isNotNullObject,
  randomString,
} from "@/helpers/units";

class ApiService {
  sender: Sender;

  authToken: null | string = null;
  patientid: null | string = null;

  localStorageSessionTokenKey = "bHN0b2tlbnRlc3Q=";
  localStorageAuthTokenKey = "YXV0aFRva2Vu";
  localStoragePatientIdKey = "UGF0aWVudElk";
  /**
   * Необходим для запросов к апи
   */
  sessionToken = "";

  constructor() {
    this.sender = new Sender("https://www.hospital70.ru/app/api");
    // this.sender = new Sender("https://www.hospital70.ru/app/api/MSCH70_api_proxy/api");
    // this.sender = new Sender("http://localhost:7575/proxy");
    // this.sender = new Sender("http://172.22.0.84:8082/api/lk/api");
    // this.sender = new Sender("https://www.hospital70.ru/api/lk/api");
    const localStorageSessionToken = localStorage.getItem(
      this.localStorageSessionTokenKey
    );
    if (localStorageSessionToken) {
      this.sessionToken = localStorageSessionToken;
    } else {
      this.sessionToken = randomString(32);
      localStorage.setItem(this.localStorageSessionTokenKey, this.sessionToken);
    }

    const localStorageAuthToken = localStorage.getItem(
      this.localStorageAuthTokenKey
    );
    if (localStorageAuthToken) {
      this.authToken = localStorageAuthToken;
    }

    const localStoragePatientId = localStorage.getItem(
      this.localStoragePatientIdKey
    );
    if (localStoragePatientId) {
      this.patientid = localStoragePatientId;
    }
  }

  send(to: ISenderSendParams) {
    if (!to.headers) to.headers = {};

    to.headers.sessiontoken = this.sessionToken;

    if (this.authToken !== null) {
      assignObject(
        {
          Authorization: `${this.authToken}`,
        },
        to.headers
      );
    }

    if (this.patientid !== null) {
      assignObject(
        {
          patientid: this.patientid,
        },
        to.headers
      );
    }

    return new Promise<Record<string, unknown>>((resolve, rej) => {
      this.sender
        .send(to)
        .then((response) => {
          if (!response.data && typeof response.data !== "object")
            return rej(response);

          if (response.data.success) {
            return resolve(response.data.data ?? {});
          }

          if (response.data && !response.data?.msg) {
            return resolve(response.data);
          }

          return rej(response.data.msg);
        })
        .catch((err) => {
          rej(err);
        });
    });
  }

  download(to: ISenderSendParams) {
    const a = document.createElement("a");
    a.href = this.sender.getDownloadLink(to);
    a.download = "file.pdf";
    a.target = "_blank";
    a.click();
    return a.href;
  }

  setAuth(token: string, patientid: string) {
    this.authToken = token;
    this.patientid = patientid;
    localStorage.setItem(this.localStorageAuthTokenKey, token);
    localStorage.setItem(this.localStoragePatientIdKey, patientid);
  }
  clearAuth() {
    localStorage.removeItem(this.localStorageAuthTokenKey);
    localStorage.removeItem(this.localStoragePatientIdKey);
    localStorage.removeItem(this.localStorageSessionTokenKey);
    this.authToken = null;
    this.patientid = null;
  }
}

export const apiService = new ApiService();

export type ApiResponseType = Record<string, unknown>;

export const ApiArrayGetter = <P, T>(
  to: ISenderSendParams,
  Constructor: new (obj: Record<string, unknown>) => T
) => {
  if (!to.data || !isNotNullObject(to.data)) {
    to.data = {};
  }

  return (params?: P) => {
    if (params) Object.assign(to.data as object, params);

    return new Promise<T[]>((resolve, reject) => {
      apiService
        .send(to)
        .then((response) => {
          if (Array.isArray(response)) {
            const arr: T[] = [];
            response.forEach((e) => {
              if (isNotNullObject(e)) arr.push(new Constructor(e));
            });
            resolve(arr);
            return;
          } else if (Array.isArray(response?.research_child_list)) {
            const arr: T[] = [];
            response.research_child_list.forEach((e) => {
              if (isNotNullObject(e)) arr.push(new Constructor(e));
            });
            resolve(arr);
            return;
          } else {
            reject("response data in not an array!");
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};
